<template>
  <div style="overscroll-behavior: none " >

    <fullscreen ref="fullscreen" @change="fullscreenChange">
      <div class="draw-box" v-if="this.sign == true">
        <canvas id="drawcanvas"></canvas>
        กรุณาเซ็นชื่อในกล่องด้านบน <br>
        <input type="button" class="btn-danger" style="width: 100px; height: 50px" value="ยกเลิก" @click="cancelDraw()" />
        <input type="button" class="btn-primary"  style="width: 100px; height: 50px" value="บันทึก"  @click="saveDraw()" />
        <!--            <div id="output"></div>-->
      </div>
    </fullscreen>

    <!--        <div class="form-frame" v-bind:class="[(this.sign === true) ? signActiveClass : '']"  >-->
    <div class="form-frame" :class="computedClass">
      <div v-bind:class="[(this.sign === true) ? signActiveClass : '']"  >
        <b-row>
          <b-col align="right">หน้า 2/3</b-col>
        </b-row>
        <!--        No -->
        <b-row class="row" >
          <b-row>
            <b-col md="4" align="left" style="padding-left: 30px">เลขที่ชันสูตร</b-col>
            <b-col>
              <input class="custom-input" style="background: #F2F2F2" readonly="true" type="text" v-model="form.case_id">
            </b-col>
          </b-row>
        </b-row>
        <!--        10 cont. -->

        <!--        11 -->
        <b-row class="row">
          <b-col cols="12" lg="12" md="12" sm="12">
            <b-row align="left">
              <b-col lg="12" style="padding-right: 0">11. การเปลี่ยนแปลงหลังการตาย
                <a class="radio-label" style="color: #2DA1A9" v-b-toggle.transformations-collapse><b-icon icon="pencil-fill"></b-icon> กรอกข้อมูล</a>
              </b-col>
            </b-row>
          </b-col>
          <b-collapse id="transformations-collapse">
          <b-col lg=12 style="padding: 0 30px">
            <b-row align="left">
              <b-col lg="12" sm="12" md="5" style="padding-right: 0">11.1 การกระตุ้นกล้ามเนื้อลาย (Supravital Reaction)
                <div class="waring-message" v-if="msg_supravital_reaction_id">กรุณาเลือก</div>
              </b-col>
              <b-col style="padding-left: 0;font-weight: normal">
                <b-form-radio-group id="radio-group-1" @input="updateForm('supravital_reaction_id',null,'transformations')"  v-model="transformations.supravital_reaction_id">
                  <b-col cols="12" sm="12">
                    <label class="radio-label">
                      <b-form-radio class="radio-135" value="1" >บวก</b-form-radio>
                    </label>
                    <label class="radio-label">
                      <b-form-radio class="radio-135" value="2" >ลบ</b-form-radio>
                    </label>
                  </b-col>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg=12 style="padding: 0  30px">
            <b-row align="left">
              <b-col lg="12" sm="12" md="5" style="padding-right: 0">11.2 อุณหภูมิของศพโดยการสัมผัส
                <div class="waring-message" v-if="msg_temp">กรุณาเลือก</div>
              </b-col>
              <b-col style="padding-left: 0;font-weight: normal">
                <b-form-radio-group id="radio-group-2" @input="updateForm('temp',null,'transformations')"  v-model="transformations.temp">
                  <b-col cols="12" sm="12">
                    <label class="radio-label">
                      <b-form-radio class="radio-135" value="1" >อุ่น</b-form-radio>
                    </label>
                    <label class="radio-label">
                      <b-form-radio class="radio-135" value="2" >เย็น</b-form-radio>
                    </label>
                  </b-col>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col lg=12 style="padding: 0 30px">
            <b-row align="left">
              <b-col lg="12" sm="12" md="12" style="padding-right: 0">11.3 การแข็งตัวของศพ (Rigor Mortis)
              </b-col>
              <b-col style="font-weight: normal">
                <div style="padding-top: 1rem">
                  <b-table-simple small class="form-table" responsive="sm md" bordered hover>
                    <b-thead>
                      <b-tr>
                        <b-th style="padding: 0.75rem; width: 15%;">ข้อ</b-th>
                        <b-th style="padding: 0.75rem; width: 15%; text-align: center;">ไม่แข็งตัว</b-th>
                        <b-th style="padding: 0.75rem; width: 15%; text-align: center;">แข็งตัวบางส่วน</b-th>
                        <b-th style="padding: 0.75rem; width: 15%; text-align: center;">แข็งตัวเต็มที่</b-th>
                        <b-th style="padding: 0.75rem; text-align: center;">หมายเหตุ</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
<!--                      <b-form-radio-group v-model="form.jaw"  @input="updateRigorMortis(form.jaw)">-->
                      <b-tr >
                        <b-td style="padding-left: 0.75rem">
                          กราม{{form.jaw}}
                        </b-td>
                            <b-td class="table-injury-radio">
                              <input type="radio" name="jaw" value="1" v-model="form.jaw" @click="form.jaw=1" @input="updateRigorMortis(form.jaw)" />
                            </b-td>
                            <b-td class="table-injury-radio" >
                              <input type="radio" name="jaw" value="2" v-model="form.jaw" @click="form.jaw=2" @input="updateRigorMortis(form.jaw)"  />
                            </b-td>
                            <b-td class="table-injury-radio"  >
                              <input type="radio" name="jaw" value="3" v-model="form.jaw" @click="form.jaw=3" @input="updateRigorMortis(form.jaw)" />
                            </b-td>
                        <b-td style="padding: unset">
                          <b-form-input class="border-0 no-shadow p-1" v-model="form.note_jaw" @change="updateRigorMortis(form.note_jaw)"></b-form-input>
                        </b-td>
                      </b-tr>
<!--                      </b-form-radio-group>-->

                      <b-tr>
                        <b-td style="padding-left: 0.75rem">คอ</b-td>
                        <b-td class="table-injury-radio">
                          <input type="radio" name="neck" value="1" v-model="form.neck" @click="form.neck=1" @input="updateRigorMortis(form.neck)" />
                        </b-td>
                        <b-td class="table-injury-radio" >
                          <input type="radio" name="neck" value="2" v-model="form.neck" @click="form.neck=2" @input="updateRigorMortis(form.neck)"  />
                        </b-td>
                        <b-td class="table-injury-radio"  >
                          <input type="radio" name="neck" value="3" v-model="form.neck" @click="form.neck=3" @input="updateRigorMortis(form.neck)" />
                        </b-td>
                        <b-td style="padding: unset">
                          <b-form-input class="border-0 no-shadow p-1" v-model="form.note_neck" @change="updateRigorMortis(form.note_neck)"></b-form-input>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td style="padding-left: 0.75rem">ข้อนิ้ว</b-td>
                        <b-td class="table-injury-radio">
                          <input type="radio" name="knuckle" value="1" v-model="form.knuckle" @click="form.knuckle=1" @input="updateRigorMortis(form.knuckle)" />
                        </b-td>
                        <b-td class="table-injury-radio" >
                          <input type="radio" name="knuckle" value="2" v-model="form.knuckle" @click="form.knuckle=2" @input="updateRigorMortis(form.knuckle)"  />
                        </b-td>
                        <b-td class="table-injury-radio"  >
                          <input type="radio" name="knuckle" value="3" v-model="form.knuckle" @click="form.knuckle=3" @input="updateRigorMortis(form.knuckle)" />
                        </b-td>
                        <b-td style="padding: unset">
                          <b-form-input class="border-0 no-shadow p-1" v-model="form.note_knuckle" @change="updateRigorMortis(form.note_knuckle)"></b-form-input>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td style="padding-left: 0.75rem">ข้อศอก</b-td>
                        <b-td class="table-injury-radio">
                          <input type="radio" name="elbow" value="1" v-model="form.elbow" @click="form.elbow=1" @input="updateRigorMortis(form.elbow)" />
                        </b-td>
                        <b-td class="table-injury-radio" >
                          <input type="radio" name="elbow" value="2" v-model="form.elbow" @click="form.elbow=2" @input="updateRigorMortis(form.elbow)"  />
                        </b-td>
                        <b-td class="table-injury-radio"  >
                          <input type="radio" name="elbow" value="3" v-model="form.elbow" @click="form.elbow=3" @input="updateRigorMortis(form.elbow)" />
                        </b-td>
                        <b-td style="padding: unset">
                          <b-form-input class="border-0 no-shadow p-1" v-model="form.note_elbow" @change="updateRigorMortis(form.note_elbow)"></b-form-input>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td style="padding-left: 0.75rem">ข้อไหล่</b-td>
                        <b-td class="table-injury-radio">
                          <input type="radio" name="shoulder_joint" value="1" v-model="form.shoulder_joint" @click="form.shoulder_joint=1" @input="updateRigorMortis(form.shoulder_joint)" />
                        </b-td>
                        <b-td class="table-injury-radio" >
                          <input type="radio" name="shoulder_joint" value="2" v-model="form.shoulder_joint" @click="form.shoulder_joint=2" @input="updateRigorMortis(form.shoulder_joint)"  />
                        </b-td>
                        <b-td class="table-injury-radio"  >
                          <input type="radio" name="shoulder_joint" value="3" v-model="form.shoulder_joint" @click="form.shoulder_joint=3" @input="updateRigorMortis(form.shoulder_joint)" />
                        </b-td>
                        <b-td style="padding: unset">
                          <b-form-input class="border-0 no-shadow p-1" v-model="form.note_shoulder_joint" @change="updateRigorMortis(form.note_shoulder_joint)"></b-form-input>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td style="padding-left: 0.75rem">ข้อสะโพก</b-td>
                        <b-td class="table-injury-radio">
                          <input type="radio" name="hip_joint" value="1" v-model="form.hip_joint" @click="form.hip_joint=1" @input="updateRigorMortis(form.hip_joint)" />
                        </b-td>
                        <b-td class="table-injury-radio" >
                          <input type="radio" name="hip_joint" value="2" v-model="form.hip_joint" @click="form.hip_joint=2" @input="updateRigorMortis(form.hip_joint)"  />
                        </b-td>
                        <b-td class="table-injury-radio"  >
                          <input type="radio" name="hip_joint" value="3" v-model="form.hip_joint" @click="form.hip_joint=3" @input="updateRigorMortis(form.hip_joint)" />
                        </b-td>
                        <b-td style="padding: unset">
                          <b-form-input class="border-0 no-shadow p-1" v-model="form.note_hip_joint" @change="updateRigorMortis(form.note_hip_joint)"></b-form-input>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td style="padding-left: 0.75rem">ข้อเข่า</b-td>
                        <b-td class="table-injury-radio">
                          <input type="radio" name="knee_joint" value="1" v-model="form.knee_joint" @click="form.knee_joint=1" @input="updateRigorMortis(form.knee_joint)" />
                        </b-td>
                        <b-td class="table-injury-radio" >
                          <input type="radio" name="knee_joint" value="2" v-model="form.knee_joint" @click="form.knee_joint=2" @input="updateRigorMortis(form.knee_joint)"  />
                        </b-td>
                        <b-td class="table-injury-radio"  >
                          <input type="radio" name="knee_joint" value="3" v-model="form.knee_joint" @click="form.knee_joint=3" @input="updateRigorMortis(form.knee_joint)" />
                        </b-td>
                        <b-td style="padding: unset">
                          <b-form-input class="border-0 no-shadow p-1" v-model="form.note_knee_joint" @change="updateRigorMortis(form.note_knee_joint)"></b-form-input>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td style="padding-left: 0.75rem">ข้อเท้า</b-td>
                        <b-td class="table-injury-radio">
                          <input type="radio" name="ankle" value="1" v-model="form.ankle" @click="form.ankle=1" @input="updateRigorMortis(form.ankle)" />
                        </b-td>
                        <b-td class="table-injury-radio" >
                          <input type="radio" name="ankle" value="2" v-model="form.ankle" @click="form.ankle=2" @input="updateRigorMortis(form.ankle)"  />
                        </b-td>
                        <b-td class="table-injury-radio"  >
                          <input type="radio" name="ankle" value="3" v-model="form.ankle" @click="form.ankle=3" @input="updateRigorMortis(form.ankle)" />
                        </b-td>
                        <b-td style="padding: unset">
                          <b-form-input class="border-0 no-shadow p-1" v-model="form.note_ankle" @change="updateRigorMortis(form.note_ankle)"></b-form-input>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td style="padding-left: 0.75rem">อื่นๆ</b-td>
                        <b-td class="table-injury-radio">
                          <input type="radio" name="other" value="1" v-model="form.other" @click="form.other=1" @input="updateRigorMortis(form.other)" />
                        </b-td>
                        <b-td class="table-injury-radio" >
                          <input type="radio" name="other" value="2" v-model="form.other" @click="form.other=2" @input="updateRigorMortis(form.other)"  />
                        </b-td>
                        <b-td class="table-injury-radio"  >
                          <input type="radio" name="other" value="3" v-model="form.other" @click="form.other=3" @input="updateRigorMortis(form.other)" />
                        </b-td>
                        <b-td style="padding: unset">
                          <b-form-input class="border-0 no-shadow p-1" v-model="form.note_other" @change="updateRigorMortis(form.note_other)"></b-form-input>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg=12 style="padding: 0 30px">
            <b-row align="left">
              <b-col lg="12" sm="12" md="12" style="padding-right: 0">11.4
                การตกของเลือดสู่เบื้องต่ำภายหลังตาย (Livor Mortis)

                <div class="waring-message" v-if="msg_livor_mortis_id">กรุณากรอกข้อมูล</div>
              </b-col>
              <b-col style="padding-left: 0;font-weight: normal">
                <b-form-radio-group id="radio-group-3" @input="updateForm('livor_mortis_id',null,'transformations')"  v-model="transformations.livor_mortis_id">
                  <b-row style="padding: 15px 30px 0 15px">
                    <b-col cols="12" sm="12" lg="12" md="12">
                      <label class="radio-label">
                        <b-form-radio class="radio-135" value="1" >ยังไม่ปรากฏ</b-form-radio>
                      </label>
                      <label class="radio-label">
                        <b-form-radio class="radio-135" value="2" >ปรากฏเป็นจ้ำ</b-form-radio>
                      </label>
                      <label class="radio-label">
                        <b-form-radio class="radio-135" value="3" >ปรากฏเป็นปื้น</b-form-radio>
                      </label>
                    </b-col>
                  </b-row>
                  <b-row  style="padding-left: 15px;" >
                    <b-col cols="12" sm="12" lg="12" md="12">
                      ตำแหน่งที่พบ
                      <input v-on:change="updateForm('livor_mortis_area',null,'transformations')" v-model="transformations.livor_mortis_area" class="d-inline custom-input other_note_350"  type="text">
                    </b-col>
                  </b-row>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg=12 style="padding: 0 30px">
            <b-row align="left" >
              <b-col lg="12" sm="12" md="12" style="padding-right: 0">ลักษณะจางของสีเมื่อกด
                <div class="waring-message" v-if="msg_blood_type_id">กรุณากรอกข้อมูล</div>
              </b-col>
              <b-col style="font-weight: normal">
                <b-form-radio-group id="radio-group-4" @input="updateForm('blood_type_id',null,'transformations')"  v-model="transformations.blood_type_id">
                  <b-row>
                    <b-col cols="12" sm="12" lg="6" md="12">
                      <label class="radio-label">
                        <b-form-radio class="radio-135" value="1" >จาง</b-form-radio>
                      </label>
                      <label class="radio-label">
                        <b-form-radio class="radio-135" value="2" >จางเล็กน้อย</b-form-radio>
                      </label>
                      <label class="radio-label">
                        <b-form-radio class="radio-135" value="3" >ไม่จาง</b-form-radio>
                      </label>
                    </b-col>
                  </b-row>
                </b-form-radio-group>
              </b-col>
            </b-row>
            <b-row align="left">
              <b-col lg="12" sm="12" md="12" style="padding-right: 0">สีที่ปรากฏ
                <div class="waring-message" v-if="msg_blood_color_id">กรุณากรอกข้อมูล</div>
              </b-col>
              <b-col style="font-weight: normal">
                <b-form-radio-group id="radio-group-5" @input="updateForm('blood_color_id',null,'transformations')"  v-model="transformations.blood_color_id">
                  <b-row>
                    <b-col cols="12" sm="12" lg="12" md="12">
                      <label class="radio-label">
                        <b-form-radio class="radio-135" value="1" >ม่วงแดง</b-form-radio>
                      </label>
                      <label class="radio-label">
                        <b-form-radio class="radio-135" value="2" >ชมพูสด</b-form-radio>
                      </label>
                      <label class="radio-label">
                        <b-form-radio class="radio-135" value="3" >เขียวคล้ำ</b-form-radio>
                      </label>


                    </b-col>
                    <b-col  cols="12" sm="12" lg="12" md="12">
                      <label class="radio-label">
                        <b-form-radio  value="4" >อื่นๆ</b-form-radio>
                      </label>
                      <input v-if="transformations.blood_color_id == 4" v-model="transformations.blood_color_other"
                             class="d-inline custom-input other_note_350"  type="text" v-on:change="updateForm('blood_color_other',null,'transformations')">
                    </b-col>
                  </b-row>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg=12 style="padding: 0 30px">
            <b-row align="left" style="padding: 0">
              <b-col lg="12" sm="12" md="12" style="padding-right: 0">11.5 ศพเน่า
                <div class="waring-message" v-if="msg_rot_type_id">กรุณากรอกข้อมูล</div>
              </b-col>
              <b-col class="question-sub" >
                <b-form-radio-group id="radio-group-6" @input="updateForm('rot_type_id',null,'transformations')"  v-model="transformations.rot_type_id">
                  <b-row style="padding: 0 15px">
                    <b-col cols="12" sm="12" lg="12" md="12">
                      <label class="radio-label">
                        <b-form-radio class="radio-135" value="1" >ไม่เน่า</b-form-radio>
                      </label>
                      <label class="radio-label">
                        <b-form-radio class="radio-135" value="2" >เน่า</b-form-radio>
                      </label>
                      <label class="radio-label">
                        <b-form-radio class="radio-135" value="3" >หน้าท้องเริ่มเขียว</b-form-radio>
                      </label>
                      <label class="radio-label">
                        <b-form-radio class="radio-135" value="4" >Marbling</b-form-radio>
                      </label>
                      <label class="radio-label">
                        <b-form-radio class="radio-135" value="5" >ผิวหนังหลุดลอก</b-form-radio>
                      </label>
                      <label class="radio-label">
                        <b-form-radio class="radio-135" value="6" >ร่างกายพองโต</b-form-radio>
                      </label>
                    </b-col>
                    <b-col  cols="12" sm="12" lg="12" md="12">
                      <label class="radio-label">
                        <b-form-radio  value="7" >อื่นๆ</b-form-radio>
                      </label>
                      <input  v-if="transformations.rot_type_id == 7"
                              v-model="transformations.rot_type_other"
                              class="d-inline custom-input other_note_350"  type="text"
                              v-on:change="updateForm('rot_type_other',null,'transformations')">

                    </b-col>
                  </b-row>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>
          </b-collapse>

        </b-row>
        <hr>
        <!--        12 -->
        <b-row class="row">
          <b-col cols="12" lg="12" md="12" sm="12">
            <b-row align="left">
              <b-col lg="12" style="padding-right: 0">12. การบาดเจ็บ และ/หรือพยาธิสภาพที่ตรวจพบ</b-col>
            </b-row>
          </b-col>
          <b-col cols="12" lg="12" md="12" sm="12" style="padding: 0 30px">
            <b-row align="left" style="padding: 0">
              <b-col lg="12" sm="12" md="12" style="padding-right: 0">12.1 การบาดเจ็บ
                <div class="waring-message" v-if="msg_eye_injury_type_id">กรุณากรอกข้อมูล</div>
              </b-col>
              <b-col style="padding-left: 0;font-weight: normal">
                <b-form-radio-group id="radio-group-eye_injury"  @input="updateForm('eye_injury_type_id')"  v-model="form.eye_injury_type_id">
                    <b-row style="padding-left:15px" class="py-0 my-0">
                      <b-col cols="12" sm="12" lg="12" md="12">
                        <b-row>
                        <b-col lg="1" xl="1" class="text-left text-lg-right ">
                            เยื่อบุตา
                        </b-col>
                          <b-col lg="2" xl="2">
                            <label class="radio-label">
                              <b-form-radio class="radio-135" value="1" >ปกติ</b-form-radio>
                            </label>
                          </b-col>
                          <b-col  lg="2" xl="2">
                            <label class="radio-label">
                              <b-form-radio class="radio-135" value="2" >ไม่ปกติ</b-form-radio>
                            </label>
                          </b-col>
                          <b-col>
                            รายละเอียด
                            <input
                                v-on:change="updateForm('eye_injury_note')"
                                v-model="form.eye_injury_note"
                                class="d-inline custom-input other_note_350"  type="text">
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-form-radio-group>
                <b-form-radio-group id="radio-group-neck_injury" @input="updateForm('neck_injury')"  v-model="form.neck_injury">
                  <b-row style="padding-left:15px" class="py-0 my-0">
                    <b-col cols="12" sm="12" lg="12" md="12">
                      <b-row>
                        <b-col lg="1" xl="1" class="text-left text-lg-right ">
                          คอ
                        </b-col>
                        <b-col lg="2" xl="2">
                          <label class="radio-label">
                            <b-form-radio class="radio-135" value="1" >ปกติ</b-form-radio>
                          </label>
                        </b-col>
                        <b-col  lg="2" xl="2">
                          <label class="radio-label">
                            <b-form-radio class="radio-135" value="2" >ไม่ปกติ</b-form-radio>
                          </label>
                        </b-col>
                        <b-col>
                          รายละเอียด
                          <input
                              v-on:change="updateForm('neck_injury_note')"
                              v-model="form.neck_injury_note"
                              class="d-inline custom-input other_note_350"  type="text">
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  </b-form-radio-group>
                <b-form-radio-group id="radio-group-arm_injury"  @input="updateForm('arm_injury')"  v-model="form.arm_injury">
                  <b-row style="padding-left:15px" class="py-0 my-0">
                    <b-col cols="12" sm="12" lg="12" md="12">
                      <b-row>
                        <b-col lg="1" xl="1" class="text-left text-lg-right ">
                          แขน
                        </b-col>
                        <b-col lg="2" xl="2">
                          <label class="radio-label">
                            <b-form-radio class="radio-135" value="1" >ปกติ</b-form-radio>
                          </label>
                        </b-col>
                        <b-col  lg="2" xl="2">
                          <label class="radio-label">
                            <b-form-radio class="radio-135" value="2" >ไม่ปกติ</b-form-radio>
                          </label>
                        </b-col>
                        <b-col>
                          รายละเอียด
                          <input
                              v-on:change="updateForm('arm_injury_note')"
                              v-model="form.arm_injury_note"
                              class="d-inline custom-input other_note_350"  type="text">
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  </b-form-radio-group>
                <b-form-radio-group id="radio-group-leg_injury"  @input="updateForm('leg_injury')"  v-model="form.leg_injury">
                  <b-row style="padding-left:15px" class="py-0 my-0">
                    <b-col cols="12" sm="12" lg="12" md="12">
                      <b-row>
                        <b-col lg="1" xl="1" class="text-left text-lg-right ">
                          ขา
                        </b-col>
                        <b-col lg="2" xl="2">
                          <label class="radio-label">
                            <b-form-radio class="radio-135" value="1" >ปกติ</b-form-radio>
                          </label>
                        </b-col>
                        <b-col  lg="2" xl="2">
                          <label class="radio-label">
                            <b-form-radio class="radio-135" value="2" >ไม่ปกติ</b-form-radio>
                          </label>
                        </b-col>
                        <b-col>
                          รายละเอียด
                          <input
                              v-on:change="updateForm('leg_injury_note')"
                              v-model="form.leg_injury_note"
                              class="d-inline custom-input other_note_350"  type="text">
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg=12 style="padding: 0 30px">
            <b-row align="left" style="padding: 0.5rem 0">
              <b-col lg="12" sm="12" md="12" style="padding-right: 0">12.2 สภาพพยาธิอื่นๆ
                <div class="waring-message" v-if="msg_is_body_injury_found">กรุณากรอกข้อมูล</div>
              </b-col>
              <b-col style="padding-left: 0;font-weight: normal">
                <b-form-radio-group id="radio-group-8" @input="updateForm('is_body_injury_found')"  v-model="form.is_body_injury_found">
                  <b-row style="padding: 0 15px">
                    <b-col cols="12" sm="12" lg="12" md="12">
                      <label class="radio-label">
                        <b-form-radio class="radio-135" value="1" >ไม่พบ</b-form-radio>
                      </label>
                      <label class="radio-label">
                        <b-form-radio class="radio-135" value="2" >พบ (ระบุ)</b-form-radio>
                      </label>
                      <input v-if="form.is_body_injury_found == 2"
                             v-on:change="updateForm('body_injury_found')"
                             v-model="form.body_injury_found"
                             class="d-inline custom-input other_note_350"  type="text">
                    </b-col>
                  </b-row>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg=12 style="padding: 0 30px">
            <b-row align="left" style="padding: 0">
              <b-col lg="12" sm="12" md="12" style="padding-right: 0">12.3 บาดแผลที่ตรวจ
                <div class="waring-message" v-if="msg_is_has_injury">กรุณากรอกข้อมูล</div>
              </b-col>
              <b-col style="padding-left: 0;font-weight: normal">
                <b-form-radio-group id="radio-group-9" @input="updateForm('is_has_injury')"  v-model="form.is_has_injury">
                  <b-row style="padding: 0 15px">
                    <b-col cols="12" sm="12" lg="12" md="12">
                      <label class="radio-label">
                        <b-form-radio class="radio-135" value="1" >ไม่พบ</b-form-radio>
                      </label>
                      <label class="radio-label">
                        <b-form-radio class="radio-135"  value="2" >พบ (ระบุในแผนภาพที่หน้า 3)</b-form-radio>
                      </label>
                    </b-col>
                  </b-row>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr>
        <!--        13 -->
        <b-row class="row" align="left" style="padding-top: 1em">
          <b-col lg="4" style="padding-right: 0">13. การเก็บวัตถุพยานจากการชันสูตรพลิกศพ
            <div class="waring-message" v-if="msg_is_evidence">กรุณากรอกข้อมูล</div>
          </b-col>
          <b-col style="font-weight: normal">
            <b-col cols="12" sm="12">
              <b-button v-b-modal.modal-item-add > เพิ่มรายการวัตถุ</b-button>
              <b-modal
                  id="modal-item-add"
                  ref="modal"
                  title="วัตถุพยานจากการชันสูตรพลิกศพ"
                  @hidden="resetModal()"
                  @ok="handleOk(true)"
                  ok-title="บันทึก"
                  cancel-title="ยกเลิก"
                  @cancel="handleOk(false)"
              >
                <form ref="form" @submit.stop.prevent="handleOk(true)">
                  <b-form-group
                      label="วัตถุพยาน"
                      label-for="evidence-input">
                    <b-form-input
                        id="evidence-input"
                        v-model="itemTemp.evidence"
                        required
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                      label="ชนิดวัตถุพยาน"
                      label-for="type-input">
                    <b-form-input
                        id="type-input"
                        v-model="itemTemp.type"
                        required
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                      label="เก็บจาก(ตำแหน่ง)"
                      label-for="location-input">
                    <b-form-input
                        id="location-input"
                        v-model="itemTemp.location"
                        required
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                      label="จำนวน"
                      label-for="amount-input">
                    <b-form-input
                        id="amount-input"
                        v-model="itemTemp.amount"
                        type="number"
                        min="1"
                        required
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                      label="รูปวัตถุพยาน"
                      label-for="image-input">
                    <div class="d-flex mb-3">
                      <b-form-file v-model="image" placeholder="เพิ่มรูป" accept="image/*" class="w-auto flex-grow-1"></b-form-file>
                      <b-button v-if="hasImage" variant="danger" class="ml-3" @click="clearImage">ลบรูป</b-button>
                    </div>
                    <b-img v-if="hasImage" :src="imageSrc" center style="max-width: 200px;max-height: 150px "class="mb-3" @click="modalShow =! modalShow" fluid block rounded></b-img>
                    <b-modal v-model="modalShow" hide-footer  header-text-variant="danger"  header-close-content="ปิด(X)"  size="100%" centered >
                      <b-img :src="imageSrc" style="width: 100%"></b-img>
                    </b-modal>
                  </b-form-group>
                </form>
              </b-modal>

            </b-col>
          </b-col>
        </b-row>
        <div >
          <b-table v-if="itemsKeep.length > 0" class="form-table" responsive="sm md" bordered hover :items="itemsKeep" style="text-align: center" :fields="fieldsItemKeep">
            <template v-slot:cell(no)="data">
              {{ data.index + 1 }}
            </template>
            <template v-slot:cell(image_evidence)="row">
              <img v-if="row.item && row.item.image_evidence"  :src="row.item.image_evidence"  style="max-width: 100px;" alt="">
            </template>

            <template v-slot:cell(actions)="row">
              <b-button size="sm" @click="showEditEvidentItemForm(row)" v-b-modal.modal-item-add class="mr-1">
                แก้ไข
              </b-button>
              <b-button size="sm" @click="deleteItem(row.item,row.index)" class="mr-1">
                ลบ
              </b-button>
            </template>

          </b-table>
        </div>
        <hr>
        <!--        14 -->
        <b-row class="row">
          <b-col cols="12" lg="12" md="12" sm="12">
            <b-row align="left">
              <b-col lg="3" style="padding-right: 0">14. ข้อสันนิษฐานการตายเบื้องต้น</b-col>
              <b-col>
                <input v-on:change="updateForm('assumed_cause')" v-model="form.assumed_cause" class="custom-input" type="text">
                <div style="color: red;font-size: 10px;width: 100%;text-align: center;font-weight: normal" v-if="msg_assumed_cause">กรุณากรอกข้อมูล</div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr>
        <!--        15 -->
        <b-row class="row">
          <b-col cols="12" lg="12" md="12" sm="12" style="padding-right: 0">15. ได้จัดการกับศพนั้นอย่างไร
            <div class="waring-message" v-if="msg_dead_management_id">กรุณากรอกข้อมูล</div>
          </b-col>
          <b-col style="font-weight: normal">
            <b-form-radio-group id="radio-group-11" @input="updateForm('dead_management_id')" v-model="form.dead_management_id">
              <b-row style="padding-left: 15px">
                <b-col cols="12" sm="12" lg="12" md="12">
                  <label class="radio-label">
                    <b-form-radio class="radio-135" value="1" >มอบให้ญาติ</b-form-radio>
                  </label>
                  <label class="radio-label">
                    <b-form-radio class="radio-135" value="2" >ส่งเข้า รพ. เพื่อตรวจเพิ่มเติม</b-form-radio>
                  </label>
                  <label class="radio-label">
                    <b-form-radio class="radio-135" value="3" >ส่งผ่าศพที่ รพ.</b-form-radio>
                  </label>
                </b-col>
                <b-col cols="12" sm="12" lg="12" md="12" >
                  <label class="radio-label">
                    <b-form-radio  value="4" >อื่นๆ</b-form-radio>
                  </label>
                  <input  v-if="form.dead_management_id == 4" v-on:change="updateForm('dead_management_other')" v-model="form.dead_management_other"
                          class="d-inline custom-input other_note_350" type="text">

                </b-col>
              </b-row>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <!--        note -->
        <b-row class="row">
          <b-col cols="12" lg="12" md="12" sm="12">
            <b-row align="left">
              <b-col lg="12" style="padding-right: 0">บันทึกอื่นๆ</b-col>
              <b-col class="mt-3">
                <b-form-textarea class="custom-input"
                                 id="textarea"
                                 rows="3"
                                 max-rows="6"
                                 style="overflow-y: hidden"
                                 v-model="form.remark"
                                 v-on:change="updateForm('remark')"
                ></b-form-textarea>
                <div style="color: red;font-size: 10px;width: 100%;text-align: center;font-weight: normal" v-if="msg_remark">กรุณากรอกข้อมูล</div>

              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <div style="border-bottom: 1px solid #2DA1A9; padding: 0 2em 2em 2em"></div>

        <!--        sign1 -->
        <b-row class="row" style="padding-top: 2em">
          <b-col cols="12" lg="4" md="4" sm="12">
            <b-row align="left" style="padding: 0 0 0 15px;">
              พนักงานสอบสวน
            </b-row>
            <b-row align="left">
              <b-col lg="12" md="12" style=" text-align: center;">
                <div id="officer_sign_img" class="signImgWrap" v-if="form.officer_sign_img" >
                  <img  class="signImg" :src="form.officer_sign_img" alt='from canvas'/>
                </div>
                <div id="officer_card_img" class="signImgWrap" v-if="form.officer_card_img" >
                  <div class="text-right">
                    <b-button style="z-index: 999;position: relative" @click="deleteCardImage('officer_card_img')">
                      <b>X</b>
                    </b-button>
                  </div>
                  <b-img v-if="form.officer_card_img && form.officer_card_img != null " class="signImg" v-b-modal.modal-officer_card_img :src="path_image+form.officer_card_img"  fluid block rounded>
                  </b-img>
                  <b-modal id="modal-officer_card_img" hide-footer  header-text-variant="danger"  header-close-content="ปิด(X)"  size="100%" centered >
                    <b-img :src="path_image+form.officer_card_img" style="max-width: 100%"></b-img>
                  </b-modal>
                </div>
                <b-btn @click="showDrawModal('officer_sign_img')"> เซ็นชื่อ </b-btn>
                <b-btn @click="$refs.file1.click()">รูปบัตร</b-btn>
                <input ref="file1" style="display: none" type="file" accept="image/*" @input="uploadCardImage('officer_card_img')">
              </b-col>
            </b-row>
              <b-row align="left">
              <div class="d-inline col-sm-12 col-lg-12 col-md-12">
                <div class="d-inline mr-3">(ลงชื่อ)</div>
                <input v-on:change="updateForm('officer_name')" v-model="form.officer_name" class="d-inline custom-input col-lg-8" type="text">
                <div style="color: red;font-size: 10px;width: 100%;text-align: center;font-weight: normal" v-if="msg_officer_name">กรุณากรอกข้อมูล</div>
              </div>
            </b-row>
            <b-row align="left">
              <div class="d-inline col-sm-12 col-lg-12 col-md-12">
                <div class="d-inline mr-2">ตำแหน่ง</div>
                <input v-on:change="updateForm('officer_position')" v-model="form.officer_position" class="d-inline custom-input col-lg-8" type="text">
                <div style="color: red;font-size: 10px;width: 100%;text-align: center;font-weight: normal" v-if="msg_officer_position">กรุณากรอกข้อมูล</div>
              </div>
            </b-row>
            <b-row align="left">
              <div class="d-inline col-sm-12 col-lg-12 col-md-12">
                <div class="d-inline mr-3" >อีเมล</div>
                <input v-on:change="updateForm('officer_email')" v-model="form.officer_email" class="d-inline custom-input col-lg-8" type="email">
                <div style="color: red;font-size: 10px;width: 100%;text-align: center;font-weight: normal" v-if="msg_officer_email">กรุณากรอกข้อมูล</div>
              </div>
            </b-row>
          </b-col>
          <b-col cols="12" lg="4" md="4" sm="12">
            <b-row align="left" style="padding: 0 0 0 15px;">
              แพทย์ผู้ชันสูตรพลิกศพ
            </b-row>
            <b-row align="left">
              <b-col lg="12" md="12" style=" text-align: center;">
                <div id="doctor_sign_img" class="signImgWrap" v-if="form.doctor_sign_img" >
                  <img class="signImg" :src="form.doctor_sign_img" alt='from canvas'/>
                </div>
                <div id="doctor_card_img" class="signImgWrap" v-if="form.doctor_card_img" >
                  <div class="text-right">
                    <b-button style="z-index: 999;position: relative" @click="deleteCardImage('doctor_card_img')">
                      <b>X</b>
                    </b-button>
                  </div>
                  <b-img v-if="form.doctor_card_img && form.doctor_card_img != null " v-b-modal.modal-doctor_card_img class="signImg" :src="path_image+form.doctor_card_img"  fluid block rounded></b-img>
                  <b-modal id="modal-doctor_card_img" hide-footer  header-text-variant="danger"  header-close-content="ปิด(X)"  size="100%" centered >
                    <b-img :src="path_image+form.doctor_card_img" style="max-width: 100%"></b-img>
                  </b-modal>
                </div>
                <b-btn @click="showDrawModal('doctor_sign_img')"> เซ็นชื่อ </b-btn>
                <b-btn @click="$refs.file2.click()">รูปบัตร</b-btn>
                <input ref="file2" style="display: none" type="file" accept="image/*" @input="uploadCardImage('doctor_card_img')">
              </b-col>
            </b-row>
            <b-row>
              <div class="d-inline col-sm-12 col-lg-12 col-md-12">
                <div class="d-inline mr-3">(ลงชื่อ)</div>
                <input v-on:change="updateForm('sign_doctor_name')" v-model="form.sign_doctor_name" class="d-inline custom-input col-lg-8" type="text">
                <div style="color: red;font-size: 10px;width: 100%;text-align: center;font-weight: normal"
                     v-if="msg_sign_doctor_name">กรุณากรอกข้อมูล</div>
              </div>
            </b-row>
            <b-row align="left">
              <div class="d-inline col-sm-12 col-lg-12 col-md-12">
                <div class="d-inline mr-2">ตำแหน่ง</div>
                <input v-on:change="updateForm('doctor_position')" v-model="form.doctor_position" class="d-inline custom-input col-lg-8" type="text">
                <div style="color: red;font-size: 10px;width: 100%;text-align: center;font-weight: normal"
                     v-if="msg_doctor_position">กรุณากรอกข้อมูล</div>

              </div>
            </b-row>
            <b-row align="left">
              <div class="d-inline col-sm-12 col-lg-12 col-md-12">
                <div class="d-inline mr-3">อีเมล@</div>
                <input v-on:change="updateForm('doctor_email')" v-model="form.doctor_email" class="d-inline custom-input col-lg-8" type="email">
                <div style="color: red;font-size: 10px;width: 100%;text-align: center;font-weight: normal"
                     v-if="msg_doctor_email">กรุณากรอกข้อมูล</div>

              </div>
            </b-row>
          </b-col>
          <b-col cols="12" lg="4" md="4" sm="12">
            <b-row align="left" style="padding: 0 0 0 15px;">
              เจ้าหน้าที่ที่ได้รับมอบหมายแทน
            </b-row>
            <b-row align="left">
              <b-col lg="12" md="12" style=" text-align: center;">
                <div id="represent_sign_img" class="signImgWrap" v-if="form.represent_sign_img" >
                  <img  class="signImg" :src="form.represent_sign_img" alt='from canvas'/>
                </div>
                <div id="represent_card_img" class="signImgWrap" v-if="form.represent_card_img" >
                  <div class="text-right">
                    <b-button style="z-index: 999;position: relative" @click="deleteCardImage('represent_card_img')">
                      <b>X</b>
                    </b-button>
                  </div>
                  <b-img v-if="form.represent_card_img && form.represent_card_img != null  "  v-b-modal.modal-represent_card_img class="signImg" :src="path_image+form.represent_card_img"  fluid block rounded></b-img>
                  <b-modal id="modal-represent_card_img" hide-footer  header-text-variant="danger"  header-close-content="ปิด(X)"  size="100%" centered >
                    <b-img :src="path_image+form.represent_card_img" style="max-width: 100%"></b-img>
                  </b-modal>
                </div>
                <b-btn @click="showDrawModal('represent_sign_img')"> เซ็นชื่อ </b-btn>
                <b-btn @click="$refs.file3.click()">รูปบัตร</b-btn>
                <input ref="file3" style="display: none" type="file" accept="image/*" @input="uploadCardImage('represent_card_img')">
              </b-col>
            </b-row>
            <b-row>
              <div class="d-inline col-sm-12 col-lg-12 col-md-12">
                <div class="d-inline mr-3">(ลงชื่อ)</div>
                <input v-on:change="updateForm('represent_name')" v-model="form.represent_name" class="d-inline custom-input col-lg-8" type="text">
                <div style="color: red;font-size: 10px;width: 100%;text-align: center;font-weight: normal"
                     v-if="msg_represent_name">กรุณากรอกข้อมูล</div>
              </div>
            </b-row>

            <b-row align="left">
              <div class="d-inline col-sm-12 col-lg-12 col-md-12">
                <div class="d-inline mr-2">ตำแหน่ง</div>
                <input v-on:change="updateForm('represent_position')" v-model="form.represent_position" class="d-inline custom-input col-lg-8" type="text">
                <div style="color: red;font-size: 10px;width: 100%;text-align: center;font-weight: normal"
                     v-if="msg_represent_position">กรุณากรอกข้อมูล</div>
              </div>
            </b-row>
            <b-row align="left">
              <div class="d-inline col-sm-12 col-lg-12 col-md-12">
                <div class="d-inline mr-3">อีเมล@</div>
                <input v-on:change="updateForm('represent_email')" v-model="form.represent_email" class="d-inline custom-input col-lg-8" type="email">
                <div style="color: red;font-size: 10px;width: 100%;text-align: center;font-weight: normal"
                     v-if="msg_represent_email">กรุณากรอกข้อมูล</div>
              </div>
            </b-row>
          </b-col>
        </b-row>
        <br/>

        <!--        sign2-->
        <b-row class="pl-3 d-inline"><b-icon-circle-fill style="color: #2DA1A9"></b-icon-circle-fill> กรณีการตายโดยการกระทำ / ในระหว่างการควบคุมของเจ้าพนักงาน
        </b-row>
        <b-row class="row" style="padding-top: 1em" >
          <b-col cols="12" lg="2" md="2" sm="12"></b-col>
          <b-col cols="12" lg="4" md="4" sm="12">
            <b-row align="left" style="padding: 0 0 0 15px;">
              พนักงานอัยการ
            </b-row>
            <b-row align="left">
              <b-col lg="12" md="12" style=" text-align: center;">
                <div id="attorney_sign_img" class="signImgWrap" v-if="form.attorney_sign_img">
                  <img  class="signImg" :src="form.attorney_sign_img" alt='from canvas'/>
                </div>
                <div id="attorney_card_img" class="signImgWrap" v-if="form.attorney_card_img" >
                  <div class="text-right">
                    <b-button style="z-index: 999;position: relative" @click="deleteCardImage('attorney_card_img')">
                      <b>X</b>
                    </b-button>
                  </div>
                  <b-img v-if="form.attorney_card_img && form.attorney_card_img != null " class="signImg" v-b-modal.modal-attorney_card_img :src="path_image+form.attorney_card_img"  fluid block rounded></b-img>
                  <b-modal id="modal-attorney_card_img" hide-footer  header-text-variant="danger"  header-close-content="ปิด(X)"  size="100%" centered >
                    <b-img :src="path_image+form.attorney_card_img" style="max-width: 100%"></b-img>
                  </b-modal>
                </div>
                <b-btn @click="showDrawModal('attorney_sign_img')"> เซ็นชื่อ </b-btn>
                <b-btn @click="$refs.file4.click()">รูปบัตร</b-btn>
                <input ref="file4" style="display: none" type="file" accept="image/*" @input="uploadCardImage('attorney_card_img')">
              </b-col>
            </b-row>

            <b-row>
              <div class="d-inline col-sm-12 col-lg-12 col-md-12">
                <div class="d-inline mr-3">(ลงชื่อ)</div>
                <input v-on:change="updateForm('attorney_name')" v-model="form.attorney_name" class="d-inline custom-input col-lg-8" type="text">
                <div style="color: red;font-size: 10px;width: 100%;text-align: center;font-weight: normal"
                     v-if="msg_attorney_name">กรุณากรอกข้อมูล</div>
              </div>
            </b-row>
            <b-row align="left">
              <div class="d-inline col-sm-12 col-lg-12 col-md-12">
                <div class="d-inline mr-2">ตำแหน่ง</div>
                <input v-on:change="updateForm('attorney_position')" v-model="form.attorney_position" class="d-inline custom-input col-lg-8" type="text">
                <div style="color: red;font-size: 10px;width: 100%;text-align: center;font-weight: normal"
                     v-if="msg_attorney_position">กรุณากรอกข้อมูล</div>
              </div>
            </b-row>
            <b-row align="left">
              <div class="d-inline col-sm-12 col-lg-12 col-md-12">
                <div class="d-inline mr-3">อีเมล@</div>
                <input v-on:change="updateForm('attorney_email')" v-model="form.attorney_email"  class="d-inline custom-input col-lg-8" type="email">
                <div style="color: red;font-size: 10px;width: 100%;text-align: center;font-weight: normal"
                     v-if="msg_attorney_email">กรุณากรอกข้อมูล</div>
              </div>
            </b-row>
          </b-col>
          <b-col cols="12" lg="4" md="4" sm="12">
            <b-row align="left" style="padding: 0 0 0 15px;">
              พนักงานฝ่ายปกครอง
            </b-row>
            <b-row align="left">
              <b-col lg="12" md="12" style=" text-align: center;">
                <div id="admin_sign_img" class="signImgWrap" v-if="form.admin_sign_img">
                  <img  class="signImg" :src="form.admin_sign_img" alt='from canvas'/>
                </div>
                <div id="admin_card_img" class="signImgWrap" v-if="form.admin_card_img" >
                  <div class="text-right">
                    <b-button style="z-index: 999;position: relative" @click="deleteCardImage('admin_card_img')">
                      <b>X</b>
                    </b-button>
                  </div>
                  <b-img v-if="form.admin_card_img && form.admin_card_img != null " class="signImg" v-b-modal.modal-admin_card_img :src="path_image+form.admin_card_img"  fluid block rounded></b-img>
                  <b-modal id="modal-admin_card_img" hide-footer  header-text-variant="danger"  header-close-content="ปิด(X)"  size="100%" centered >
                    <b-img :src="path_image+form.admin_card_img" style="max-width: 100%"></b-img>
                  </b-modal>
                </div>
                <b-btn @click="showDrawModal('admin_sign_img')"> เซ็นชื่อ </b-btn>
                <b-btn @click="$refs.file5.click()">รูปบัตร</b-btn>
                <input ref="file5" style="display: none" type="file" accept="image/*" @input="uploadCardImage('admin_card_img')">

              </b-col>
            </b-row>

            <b-row>
              <div class="d-inline col-sm-12 col-lg-12 col-md-12">
                <div class="d-inline mr-3">(ลงชื่อ)</div>
                <input v-on:change="updateForm('admin_name')" v-model="form.admin_name" class="d-inline custom-input col-lg-8" type="text">

                <div style="color: red;font-size: 10px;width: 100%;text-align: center;font-weight: normal"
                     v-if="msg_admin_name">กรุณากรอกข้อมูล
                </div>
              </div>
            </b-row>

            <b-row align="left">
              <div class="d-inline col-sm-12 col-lg-12 col-md-12">
                <div class="d-inline mr-2">ตำแหน่ง</div>
                <input v-on:change="updateForm('admin_position')" v-model="form.admin_position" class="d-inline custom-input col-lg-8" type="text">
                <div style="color: red;font-size: 10px;width: 100%;text-align: center;font-weight: normal"
                     v-if="msg_admin_position">กรุณากรอกข้อมูล</div>
              </div>
            </b-row>
            <b-row align="left">
              <div class="d-inline col-sm-12 col-lg-12 col-md-12">
                <div class="d-inline mr-3">อีเมล@</div>
                <input v-on:change="updateForm('admin_email')" v-model="form.admin_email" class="d-inline custom-input col-lg-8" type="email">
                <div style="color: red;font-size: 10px;width: 100%;text-align: center;font-weight: normal"
                     v-if="msg_admin_email">กรุณากรอกข้อมูล</div>
              </div>
            </b-row>

          </b-col>
        </b-row>

      </div>
      <b-col>
        <div lg="4" md="4" sm="4" cols="12" align="center">
          2/3
        </div>
      </b-col>
      <b-row>

            <b-col lg="6" md="6" sm="6" cols="6" align="left">
              <b-button class="autopsy-button" @click="goToBackPage"> <b-icon icon="arrow-left-square"></b-icon> ย้อนกลับ </b-button>
            </b-col>

            <b-col lg="6" md="6" sm="6" cols="6" align="right">
              <b-button class="autopsy-button" @click="goToNextPage"> หน้าถัดไป <b-icon icon="arrow-right-square"></b-icon> </b-button>
            </b-col>


      </b-row>
      <b-row>
        <b-col lg="4" md="4" sm="4"></b-col>
            <b-col lg="4" md="4" sm="4">
              <b-button style="width:100%" class="autopsy-button" @click="goToHomePage()">เสร็จสิ้น</b-button>
            </b-col>
      </b-row>

    </div>
  </div>
</template>

<style scoped>
@media only screen and (max-width: 499px) {
  .autopsy-button{
    font-size: 14px;
    /*width: 80%;*/
    /*margin: 20px 20px 5px 5px ;*/
  }
}
.bgType1{
  background: #e6eeff;
}
.bgType2{
  background: #fcdcc0;
}
.signImg{
  width: auto; height: auto;

  border-radius: 4px;padding: 5px;
  max-height: 150px;
  max-width: 200px;

  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

}

.signImgWrap{
  border: 1px solid #ddd;
  height: 150px;
  width: 100%;
  vertical-align: middle;
  alignment: center;
  position: relative;
}

canvas {
  cursor: crosshair;
  border: 1px solid #000000;
}

.table-injury-radio{
  text-align: center;
}


.custom-input::placeholder {
  color: #2DA1A9;
}

.row {
  padding: 0.5rem 0;
}

.question-sub-choice{
  padding: 0 15px
}

.question-sub{
  padding-left: 0;
  font-weight: normal;
}

.waring-message{
  color: red;
  font-size: 10px;
  width: 100%;
  text-align: start;
  font-weight: normal
}

.other_note_250{
  width: 250px;
  max-width: 100%
}

.other_note_350{
  width: 350px;
  max-width: 100%
}

.modal-fullscreen1 .modal {
  padding: 0 !important;
}
.modal-fullscreen1 .modal-dialog {
  max-width: 100%;
  height: 100%;
  margin: 0;
}
.modal-fullscreen1 .modal-content {
  border: 0;
  border-radius: 0;
  min-height: 100%;
  height: auto;
}

.draw-box{
  z-index: 9999;
  background-color: white;
  position:fixed;
  top:0;
  left: 0;
  width: 100%;
  height: 100%;
}

.hide-form{
  height: 0% !important;
  overflow: hidden;
}

</style>

<script>
import {mapState} from "vuex";
import Editor from 'vue-image-markup';
import $ from 'jquery'
import {domain} from "@/util/Constants";
import {domain_img_evidence} from "@/util/Constants";

const base64Encode = data =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(data);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

export default {
  name: "form2",
  components: {
    'Editor': Editor
  },
  data() {
    return {
      fullscreen: false,

      officer_card_img:null,
      doctor_card_img:null,
      represent_card_img:null,
      attorney_card_img:null,
      admin_card_img:null,
      cardImg:null,
      path_image : null,
      image:null,
      imageSrc: null,
      isAdding: true,
      modalShow: false,
      itemTemp: {
        index : 0,
        evidence: '',
        type: '',
        location: '',
        amount: 1,
        image_evidence: null,
      },
      itemTable: {
        index : 0,
        evidence: '',
        type: '',
        location: '',
        amount: 1,
        image_evidence: null,
      },
      itemKeepForm: {
        evidence: '',
        type: '',
        location: '',
        amount: 1,
        image_evidence: null,
        isUpdate: false
      },
      fieldsItemKeep: [
        {
          key: 'no',
          label: 'ลำดับที่',
        },
        {
          key: 'evidence',
          label: 'วัตถุพยาน',
        },
        {
          key: 'type',
          label: 'ชนิดวัตถุพยาน',
        },
        {
          key: 'location',
          label: 'เก็บจาก(ตำแหน่ง)',
        },
        {
          key: 'amount',
          label: 'จำนวน',
        },
        {
          key: 'image_evidence',
          label: 'รูป',
        },
        {   key: 'actions',
          label: 'แก้ไข'
        }
      ],
      itemsKeep: [],
      //msg error
      msg_cloth: false,
      msg_accessory: false,
      msg_defect: false,
      msg_livor_mortis_id: false,
      msg_blood_type_id: false,
      msg_blood_color_id: false,
      msg_rot_type_id: false,

      //12 msg table case
      msg_eye_injury_type_id: false,
      msg_eye_injury_type_other: false,
      msg_is_body_injury_found: false,
      msg_body_injury_found: false,
      msg_is_has_injury: false,
      msg_has_injury: false, //ไม่ได้ใส่
      msg_is_evidence: false,
      msg_evidences: false, //ไมไ่ด้ใส่
      msg_assumed_cause: false,
      msg_dead_management_id: false,
      msg_dead_management_other: false,
      msg_remark: false,
      msg_officer_name: false,
      msg_officer_email: false,
      msg_officer_position: false,
      msg_sign_doctor_name: false,
      msg_doctor_email: false,
      msg_doctor_position: false,
      msg_represent_name: false,
      msg_represent_email: false,
      msg_represent_position: false,
      msg_attorney_name: false,
      msg_attorney_email: false,
      msg_attorney_position: false,
      msg_admin_name: false,
      msg_admin_email: false,
      msg_admin_position: false,
      //11.1 11.2
      msg_supravital_reaction_id:false,
      msg_temp:false,

      //13
      item_found_amount : null,

      // Draw Data
      canvas: null,
      ctx: null,
      canvasx         : null,
      canvasy         : null,
      last_mousex     : null,
      last_mousey     : null,
      mousex          : null,
      mousey          : null,
      mousedown       : null,
      tooltype: "draw",
      canvasWidth: '100vw',
      canvasHeight: '100vh',
      sign: false,
      signName: null,
      minDrawX: 9999,
      minDrawY: 9999,
      maxDrawX: 0,
      maxDrawY: 0,
      signActiveClass: "hide-form"
    }
  },
  computed: {
    ...mapState({
      username:state => state.Auth.username,
      startLocation: state => {
        return state.Event.startLocation;
      },
      dataEventform: state=>{
        return state.Eventform.createCase;
      },
      dataEditform: state=>{
        return state.Eventform.case;
      },
      form: state => {
        return state.Eventform.form;
      },
      evidences: state => {
        return state.Eventform.evidences;
      },
      transformations: state => {
        return state.Eventform.transformations;
      },
      computedClass(){
        let classStyle = this.form.event_type;
        if (classStyle == '1') {
          classStyle = "bgType1";
        }else if (classStyle == '2'){
          classStyle = "bgType2";
        }
        return classStyle;
      },
      hasImage() {
        return (!!this.image || this.imageSrc != null);
      },

    }),
  },
  watch:{
    evidences: function (val) {
      console.log('watch evidence', val);
      this.itemsKeep = val
    },
    image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
              .then(value => {
                this.imageSrc = value;
              })
              .catch(() => {
                this.imageSrc = null;
              });
        } else {
          this.imageSrc = null;
        }
      }
    }

  },
  async created() {
   await this.prepare_form_data_page2();

  },
  methods: {
   async prepare_form_data_page2() {
      await this.$store.dispatch("Eventform/onGetCaseSituation");
      await this.$store.dispatch("Eventform/onGetCaseHospital");
      this.path_image = domain_img_evidence;
      this.$swal.close();
      if (this.dataEventform.case_id){
        this.case_id = this.dataEventform.case_id;
        this.id = this.dataEventform.id;
      }
      this.itemsKeep = this.evidences;
      console.log('evidences1',this.itemsKeep, this.evidences)
      console.log('transformations', this.transformations)
      console.log('this.form.neck', this.form.neck)
    },
    toggle () {
      this.$refs['fullscreen'].toggle() // recommended
    },
    fullscreenChange (fullscreen) {
      this.fullscreen = fullscreen
    },
    clearImage() {
      this.image = null;
    },
    showDrawModal(signName){
      this.$refs['fullscreen'].toggle()

      this.sign = true;
      this.signName = signName;
      let self = this;
      setTimeout(function(){ self.setupDraw() }, 10);
    },
    setupDraw(){

      //Canvas
      this.canvas = document.getElementById('drawcanvas');
      console.log(this.canvas)
      this.ctx = this.canvas.getContext('2d');
      console.log(this.ctx)

      window.addEventListener('resize', this.resizeCanvas, false);
      this.resizeCanvas();
//Variables
      this.canvasx = $(this.canvas).offset().left;
      this.canvasy = $(this.canvas).offset().top;
      this.last_mousex  = 0;
      this.last_mousey  = 0;
      this.mousex  = 0;
      this.mousey  = 0;
      this.mousedown = false;
      this.tooltype = 'draw';
      this.minDrawX = 99999;
      this.minDrawY = 99999;
      this.maxDrawX = 0;
      this.maxDrawY = 0;

      //Mousedown
      var self = this;
      $(this.canvas).on('mousedown', function(e) {
        self.actionMousedown(e)
      });
      //Mouseup

      $(this.canvas).on('mouseup', function(e) {
        self.actionMouseup(e);
      });

      //Mousemove
      $(this.canvas).on('mousemove', function(e) {
        self.actionMousemove(e)
      });

      // Set up touch events for mobile, etc

      this.canvas.addEventListener("touchstart", function (e) {
        var touch = e.touches[0];
        var mouseEvent = new MouseEvent("mousedown", {
          clientX: touch.clientX,
          clientY: touch.clientY
        });
        self.actionMousedown(mouseEvent);
      }, false);
      this.canvas.addEventListener("touchend", function (e) {
        var mouseEvent = new MouseEvent("mouseup", {});
        self.actionMouseup(mouseEvent);
      }, false);
      this.canvas.addEventListener("touchmove", function (e) {
        var touch = e.touches[0];
        var mouseEvent = new MouseEvent("mousemove", {
          clientX: touch.clientX,
          clientY: touch.clientY
        });
        self.actionMousemove(mouseEvent);
      }, false);

    },
    actionMousedown(e){
      this.last_mousex = this.mousex = parseInt(e.clientX);
      this.last_mousey = this.mousey = parseInt(e.clientY);
      this.mousedown = true;
    },
    actionMouseup(e){
      this.mousedown = false;
      // $('#output').html('current: '+this.mousex+', '+this.mousey+'<br/>last: '+this.last_mousex+', '+this.last_mousey+'<br/>mousedown: '+this.mousedown);
    },
    actionMousemove(e){
      this.mousex = parseInt(e.clientX);
      this.mousey = parseInt(e.clientY);


      if(this.mousedown) {
        if (this.maxDrawX < this.mousex){
          this.maxDrawX = this.mousex
        }
        if (this.maxDrawY < this.mousey){
          this.maxDrawY = this.mousey
        }

        if (this.minDrawX > this.mousex){
          this.minDrawX = this.mousex
        }

        if (this.minDrawY > this.mousey){
          this.minDrawY = this.mousey
        }

        this.ctx.beginPath();
        if(this.tooltype =='draw') {
          this.ctx.globalCompositeOperation = 'source-over';
          this.ctx.strokeStyle = 'blue';
          this.ctx.lineWidth = 3;
        } else {
          this.ctx.globalCompositeOperation = 'destination-out';
          this.ctx.lineWidth = 10;
        }
        this.ctx.moveTo( this.last_mousex, this.last_mousey);
        this.ctx.lineTo( this.mousex, this.mousey);
        this.ctx.lineJoin = this.ctx.lineCap = 'round';
        this.ctx.stroke();
      }
      this.last_mousex =  this.mousex;
      this.last_mousey =  this.mousey;
      //Output
      // $('#output').html('current: '+this.mousex+', '+this.mousey+'<br/>last: '+this.last_mousex+', '+this.last_mousey+'<br/>mousedown: '+this.mousedown);
    },
    resizeCanvas() {
      this.canvas.width = window.innerWidth;
      this.canvas.height = window.innerHeight * 0.7;
    },
    cancelDraw() {
      this.$refs['fullscreen'].toggle()
      this.sign = false;
    },
    saveDraw(){
      this.$refs['fullscreen'].toggle()
      var padding = 5;

      this.minDrawX = this.minDrawX - padding;
      this.maxDrawX = this.maxDrawX + padding;
      this.minDrawY = this.minDrawY - padding;
      this.maxDrawY = this.maxDrawY + padding;

      console.log(this.minDrawX,this.maxDrawX, this.minDrawY,this.maxDrawY)


      var newCanvas = document.createElement('canvas');
      newCanvas.width =  this.maxDrawX - this.minDrawX;
      newCanvas.height = this.maxDrawY - this.minDrawY;

      var newContext = newCanvas.getContext('2d');
      newContext.drawImage(
          this.canvas,
          this.minDrawX,
          this.minDrawY,
          newCanvas.width,
          newCanvas.height,
          0,
          0,
          newCanvas.width,
          newCanvas.height
      );

      // TODO Save sign Image to Server
      this.sign = false;
      var d= newCanvas.toDataURL("image/png");
      var self = this;

      setTimeout(function(){
        // $('#'+self.signName ).html("<img class="signImg" src='"+d+"' alt='from canvas'/>");
        let data = {
          id: self.form.id,
          item: {
            img : d,
            key : self.signName
          }
        };

        self.$store.dispatch("Eventform/saveImage", data);
      }, 10);


    },
    getTouchPos(canvasDom, touchEvent) {
      var rect = canvasDom.getBoundingClientRect();
      return {
        x: touchEvent.touches[0].clientX - rect.left,
        y: touchEvent.touches[0].clientY - rect.top
      };
    },
    use_tool(tool) {
      this.tooltype = tool; //update
    },
    goToBackPage() {
      let data = {
        id : this.form.id
      }
      this.$store.dispatch("Eventform/onGetCaseID",data);
      this.$store.dispatch("Eventform/onGetAppearancesID",data);
      this.$store.dispatch("Eventform/onGetTransformationID",data)
      const path = `/question-form/1`
      if (this.$route.path !== path) this.$router.push(path)
    },
    goToNextPage() {
      let data = {
        id : this.form.id
      }
      this.$store.dispatch("Eventform/onGetCaseID",data);
      this.$store.dispatch("Eventform/onGetAppearancesID",data);
      this.$store.dispatch("Eventform/onGetTransformationID",data)
      const path = `/question-form/3`
      if (this.$route.path !== path) this.$router.push(path)
    },
    goToHomePage() {
      const path = `/home`
      if (this.$route.path !== path) this.$router.push(path)
    },
    showEditEvidentItemForm(item) {
      console.log("showEditEvidentItemForm",item)

      this.isAdding = false;
      let text  = JSON.stringify(item, null, 2)
      // alert(text);
      this.image = null;

      if (item.item.image_evidence != null && item.item.image_evidence != '' ){
        // this.imageSrc = this.path_image+item.item.image_evidence;
        this.imageSrc = item.item.image_evidence;
      }

      console.log('index', item.index, this.itemTemp.index)
      this.itemTemp.index = item.index;

      // this.itemTable = item.item;

          this.itemTemp.evidence=item.item.evidence
          this.itemTemp.type=item.item.type
          this.itemTemp.location=item.item.location
          this.itemTemp.amount=item.item.amount

      // this.itemTemp = item.item;
      // this.itemKeepForm = item.item;

      // this.itemKeepForm.image_evidence = this.imageSrc;
    },
    deleteItem(item,index) {
      this.$confirm(
          {
            message: `โปรดยืนยันการลบรายการ`,
            button: {
              no: 'ยกเลิก',
              yes: 'ยืนยัน'
            },
            /**
             * Callback Function
             * @param {Boolean} confirm
             */
            callback: confirm => {
              if (confirm) {
                this.itemsKeep.splice(index, 1);
                let data = {
                  id:this.form.id,
                  no:item.no
                }
                console.log("data no",data.id)
                this.$store.dispatch("Eventform/onDeleteEvidence", data).then(() => {
                  console.log("finish delete", this.itemsKeep)
                });
              }
            }
          }
      )
    },

    updateForm(field_name, child = null, table=null, val=null){
      let value = null;
      let data = {};
      data['id'] = this.form.id;
      if(!table){
        if(child) {
          value = this.form[field_name][child]
        } else {
          value = this.form[field_name]
        }
        data[field_name] = value;
        this.$store.dispatch("Eventform/putCaseData", data);

      } else if (table === 'transformations'){
        if(child) {
          value = this.transformations[field_name][child]
        } else {
          value = this.transformations[field_name]
        }
        data[field_name] = value;
        console.log('set data',data.id,value, val)
        this.$store.dispatch("Eventform/putTransformationData", data);
      }
    },
    updateRigorMortis (input) {
      if(input){
        let dataJSON = {
          jaw : this.form.jaw,
          neck : this.form.neck,
          knuckle : this.form.knuckle,
          elbow : this.form.elbow,
          shoulder_joint : this.form.shoulder_joint,
          hip_joint : this.form.hip_joint,
          knee_joint : this.form.knee_joint,
          ankle : this.form.ankle,
          other : this.form.other,
          note_jaw : this.form.note_jaw,
          note_neck : this.form.note_neck,
          note_knuckle : this.form.note_knuckle,
          note_elbow : this.form.note_elbow,
          note_shoulder_joint : this.form.note_shoulder_joint,
          note_hip_joint : this.form.note_hip_joint,
          note_knee_joint : this.form.note_knee_joint,
          note_ankle : this.form.note_ankle,
          note_other : this.form.note_other,
        };
        let myJSONdata = JSON.stringify(dataJSON)
        let TransformationData = {
          id: this.form.id,
          rigor_mortis: myJSONdata
        };
        this.$store.dispatch("Eventform/putTransformationData", TransformationData);
      }
    },
    // Model Method
    resetModal(){
      this.isAdding = true;
      this.itemTemp=[];
      this.itemTable= {
        evidence: '',
        type: '',
        location:'',
        amount: '',
        image_evidence:null,
      }
      this.image=null;
      this.imageSrc=null;
      // return this.itemsKeep = this.evidences
    },
   async handleOk(isSave){
      if (isSave == true){
          console.log('handleOk itemTemp',this.itemTemp)
          this.itemTemp.image_evidence = this.imageSrc;
          delete this.itemTemp.image;
          delete this.itemTemp.imageSrc;

          this.itemKeepForm.evidence =  this.itemTemp.evidence;
          this.itemKeepForm.type =  this.itemTemp.type;
          this.itemKeepForm.location =  this.itemTemp.location;
          this.itemKeepForm.amount =  this.itemTemp.amount;
          this.itemKeepForm.image_evidence =  this.itemTemp.image_evidence;
          this.itemKeepForm.isUpdate =  true;

          if(this.isAdding){
            console.log('Adding....')
            let obj = {no: this.itemsKeep.lastIndex}
            this.itemsKeep.push({...this.itemKeepForm,...obj})
          }else{
            console.log('Editing....')
            this.itemsKeep[this.itemTemp.index] = this.itemKeepForm;
          }
            console.log('itemsKeep',this.itemsKeep)
            this.itemsKeep.forEach((value, index) => {
            value['no'] = index + 1;
            value['case_id'] = this.form.id
            })
            let evidence_data = {
                id : this.form.id,
                items : this.itemsKeep,
            }
            console.log("evidence_data",evidence_data)
            await this.$store.dispatch("Eventform/addEvidence", evidence_data);
            this.resetModal();
      }else {
          this.resetModal();
      }
   },
   async uploadCardImage(typeImg){

      let imgData;

      switch (typeImg){
        case  'officer_card_img': {
           imgData = this.$refs.file1.files;
          break;
        }
        case  'doctor_card_img': {
           imgData = this.$refs.file2.files;
          break;
        }

        case  'represent_card_img': {
           imgData = this.$refs.file3.files;
          break;
        }

        case  'attorney_card_img': {
           imgData = this.$refs.file4.files;
          break;
        }

        case  'admin_card_img': {
           imgData = this.$refs.file5.files;
          break;
        }
      }


      console.log("imgtes",imgData[0],typeImg)
      let data = {
      id:this.form.id,
      name: typeImg,
      case_id:this.form.case_id,
      img:''
    }
      var reader = new FileReader();
      reader.readAsDataURL(imgData[0]);
      reader.onload = ()=> {
        data.img = reader.result;
        // this.officer_card_img = reader.result;

        this.$store.dispatch("Eventform/onUploadCardImg", data).then(res =>{
          this.$store.dispatch("Eventform/onGetImgCard", data)
        })
        console.log("data.img",data)
      };

    },
    deleteCardImage(typeImg){
      let data = {
        id:this.form.id,
        name: typeImg,
        case_id:this.form.case_id,
        mode:'signCard'
      }
      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      this.$confirm(
          {
            message: `โปรดยืนยันการลบรายการ`,
            button: {
              no: 'ยกเลิก',
              yes: 'ยืนยัน'
            },
            /**
             * Callback Function
             * @param {Boolean} confirm
             */
            callback: confirm => {
              if (confirm) {
                this.$store.dispatch('Eventform/onDeleteCardImg',data).then((res)=>{
                  if (res.message == 200){
                    console.log("res",res)
                    Toast.fire({
                      icon: 'success',
                      title: 'ลบรูปสำเร็จ',
                    })
                  }else {
                    Toast.fire({
                      icon: 'error',
                      title: 'ผิดพลาด',
                    })

                  }
                })

              }
            }
          }
      )

    }
  }
}
</script>


